"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useProductInstallmentsStep = void 0;

var _services = require("../../services");

var _hooks = require("../../hooks");

var _utils = require("../../utils");

var _constants = require("../../constants");

const redirectEvents = {
  [_constants.ProductTypes.HOME]: _utils.redirectToHomeEquity,
  [_constants.ProductTypes.AUTO]: _utils.redirectToAutoRefi
};

const useProductInstallmentsStep = () => {
  const {
    closeSimulator,
    intendedCredit,
    setIntendedCredit,
    productType,
    overrideRedirectToAuto,
    overrideRedirectToHome
  } = (0, _hooks.useSimulator)();

  const onRequestProposalClick = product => {
    let redirectToProduct = redirectEvents[product];

    if (product === _constants.ProductTypes.AUTO && overrideRedirectToAuto) {
      redirectToProduct = overrideRedirectToAuto;
    }

    if (product === _constants.ProductTypes.HOME && overrideRedirectToHome) {
      redirectToProduct = overrideRedirectToHome;
    }

    (0, _services.dispatchRequestProposalClickEvent)((0, _utils.getProductLabel)(product));
    redirectToProduct(intendedCredit);
  };

  return {
    intendedCredit,
    productType,
    setIntendedCredit,
    closeSimulator,
    onRequestProposalClick
  };
};

exports.useProductInstallmentsStep = useProductInstallmentsStep;